import React from "react";

import { useBuildingMatchingContext } from "./BuildingMatchingContext";
import MatchingIcon from "shared/ui/dataDisplay/MatchingIcon/MatchingIcon";

interface IProps {
  expenditure: any;
}

const BuildingMatchingButton = ({ expenditure }: IProps) => {
  const isMatched = !expenditure.is_default ? true : !!expenditure?.estimate_expenditures?.length;
  const { setRelationOriginInfo, setIsInfo, setIsMatching } = useBuildingMatchingContext();

  const onClick = () => {
    setRelationOriginInfo(expenditure);
    if (!isMatched) {
      setIsMatching(true);
    } else {
      setIsInfo(true);
    }
  };
  return <MatchingIcon onClick={onClick} variant={getColor(expenditure)} isWithAttentionSign={!isMatched} />;
};

export default BuildingMatchingButton;

function getColor(exp: any) {
  if (exp.is_default) {
    return exp?.estimate_expenditures?.length ? "green" : "black";
  }
  return "blue";
}
